module.exports = __webpack_public_path__ + "img/music-audio-play.4ccd1c99.png";